import * as a from "./actions";

const initGetValue = {
  loading: false,
  success: false,
  error: null,
}

const modifyGet = (type, error = null) => {
  return {
    loading: type === 'request' ? true : false,
    success: type === 'success' ? true : false,
    error: type === 'error' ? error : null,
  }
}

const INITIAL_STATE = {
  saml: {
    data: null,
    get: initGetValue,
  },
  azuread: {
    data: null,
    get: initGetValue,
  }
};

export function sso(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case a.SAML_LOGIN.REQUEST:
      return {
        ...state,
        saml: {
          data: null,
          get: modifyGet('request')
        },
      };
    case a.SAML_LOGIN.SUCCESS:
      return {
        ...state,
        saml: {
          data: action.data,
          get: modifyGet('success')
        },
      };
    case a.SAML_LOGIN.FAILURE:
      return {
        ...state,
        saml: {
          data: null,
          get: modifyGet('error', action.error)
        },
      };
    case a.SAML_REGISTERATION.REQUEST:
      return {
        ...state,
        saml: {
          data: null,
          get: modifyGet('request')
        },
      };
    case a.SAML_REGISTERATION.SUCCESS:
      return {
        ...state,
        saml: {
          data: action.data,
          get: modifyGet('success')
        },
      };
    case a.SAML_REGISTERATION.FAILURE:
      return {
        ...state,
        saml: {
          data: null,
          get: modifyGet('error', action.error)
        },
      };
    case a.AZUREAD_LOGIN.REQUEST:
      return {
        ...state,
        azuread: {
          data: null,
          get: modifyGet('request')
        },
      };
    case a.AZUREAD_LOGIN.SUCCESS:
      return {
        ...state,
        azuread: {
          data: action.data,
          get: modifyGet('success')
        },
      };
    case a.AZUREAD_LOGIN.FAILURE:
      return {
        ...state,
        azuread: {
          data: null,
          get: modifyGet('error', action.error)
        },
      };
    case a.AZUREAD_REGISTERATION.REQUEST:
      return {
        ...state,
        azuread: {
          data: null,
          get: modifyGet('request')
        },
      };
    case a.AZUREAD_REGISTERATION.SUCCESS:
      return {
        ...state,
        azuread: {
          data: action.data,
          get: modifyGet('success')
        },
      };
    case a.AZUREAD_REGISTERATION.FAILURE:
      return {
        ...state,
        azuread: {
          data: null,
          get: modifyGet('error', action.error)
        },
      };
    default:
      return state;
  }
}

export default sso;
